/**
 * Quién tiene acceso (directo o por grupo).
 */
import React, { useState, useEffect } from 'react';

const ReportAccessUsersModal = ({ show, onClose, reportAccessUsers, reportForAccessUsers, styles }) => { // API_URL no se usa directamente aquí
    // Define la URL base de tu API, usando la variable de entorno para producción
    const API_URL_INTERNAL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    if (!show || !reportForAccessUsers) return null;

    // Asumimos que reportAccessUsers se actualiza cuando la carga termina.
    // Un estado de carga interno aquí sería redundante si el padre ya lo maneja.
    // Sin embargo, si la carga es asíncrona dentro del modal, necesitaríamos un estado de carga.
    // Por ahora, podemos inferir la carga si reportAccessUsers está vacío pero el modal está abierto.
    const isLoading = reportAccessUsers.length === 0 && show; // Simple inferencia de carga

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <h3 style={{color:'#5E35B1'}}>Usuarios con Acceso a: {reportForAccessUsers.reporteNombre}</h3>
                {isLoading ? (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#5f6368' }}>Cargando usuarios con acceso...</div>
                ) : reportAccessUsers.length > 0 ? (
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}></th>
                                <th style={styles.th}>Usuario</th>
                                <th style={styles.th}>Email</th>
                                <th style={styles.th}>Nivel de Acceso</th>
                                <th style={styles.th}>Fuente</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportAccessUsers.map(user => (
                                <tr key={user.userId} style={styles.tr}>
                                    <td>
                                        <img
                                            src={user.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.nombre)}&background=5E35B1&color=fff&size=30`}
                                            alt="Perfil"
                                            style={styles.miniProfileImage}
                                            referrerPolicy="no-referrer"
                                        />
                                    </td>
                                    <td>{user.nombre}</td>
                                    <td>{user.email}</td>
                                    <td>
                                        {user.accessType === 'view' ? 'Solo Vista' : 'Edición'}
                                    </td>
                                    <td>{user.source}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p>Ningún usuario tiene acceso directo o a través de grupos a este reporte.</p>
                )}
                <button 
                    onClick={onClose} 
                    style={{...styles.btnGray, gridColumn: 'span 1', marginTop: '20px'}}
                >
                    Cerrar
                </button>
            </div>
        </div>
    );
};

export default ReportAccessUsersModal;